import React, { useMemo } from 'react';
import { Card, Typography, Row, Col, Statistic } from 'antd';
import { GlobalOutlined, CodeOutlined, ThunderboltOutlined } from '@ant-design/icons';
import { mockWebsites, mockSnippets, mockSystemActivity } from '../Super Admin/mockData';

const { Title, Text } = Typography;

const ViewerAnalytics = () => {
  const websites = mockWebsites.length;
  const activeSnippets = useMemo(() => mockSnippets.filter(s => s.status === 'active').length, []);
  const events24h = mockSystemActivity.length; // demo count from activity mock

  return (
    <div>
      <Title level={2} style={{ marginBottom: 16 }}>Analytics & Reports (View Only)</Title>
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} md={8}>
          <Card style={{ borderRadius: 14 }}>
            <Statistic title="Websites" value={websites} prefix={<GlobalOutlined />} />
          </Card>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Card style={{ borderRadius: 14 }}>
            <Statistic title="Active Snippets" value={activeSnippets} prefix={<CodeOutlined />} />
          </Card>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Card style={{ borderRadius: 14 }}>
            <Statistic title="Events (24h)" value={events24h} prefix={<ThunderboltOutlined />} />
          </Card>
        </Col>
      </Row>

      <Card style={{ borderRadius: 14, marginTop: 16 }}>
        <Text type="secondary">You can view analytics summaries. Export and filters may be restricted in Viewer mode.</Text>
      </Card>
    </div>
  );
};

export default ViewerAnalytics;
